;(function(){
	"use strict";

	function BMCookieBanner() {
		var global = {
			analyticsScriptsLoaded: false,
			functionalScriptsLoaded: false,
			embeddedContentLoaded: false
		};

		var fn = {
			init: function() {
				// Load the Google Tag Manager script without tracking
				// BMBGThemeSettings set in theme functions.php via script localization
				if (BMBGThemeSettings && BMBGThemeSettings.GTMCode) {
					fn.initGoogleTagManager();
				}

				// Allow embedded content to be loaded if the category not shown in the banner
				if (
					window.BMCookieConsent &&
					BMBGThemeSettings &&
					!BMBGThemeSettings.showEmbeddedContentCategory
				) {
					window.BMCookieConsent.loadEmbeddedContent();
					global.embeddedContentLoaded = true
				}

				if (
					window.BMCookieConsent &&
					typeof window.BMCookieConsent.preferenceGiven === 'function' &&
					window.BMCookieConsent.preferenceGiven()
				) {
					var consent = window.BMCookieConsent.getPreferences();
					fn.onConsentSelected(consent);
				}

				document.addEventListener('bmcc-consent-selected', function (e) {
					fn.onConsentSelected(e.detail);
				});
			},

			onConsentSelected: function(consent) {
				if (
					consent.analytics &&
					!global.analyticsScriptsLoaded &&
					BMBGThemeSettings &&
					BMBGThemeSettings.GTMCode
				) {
					fn.enableGoogleAnalytics();
					global.analyticsScriptsLoaded = true;
				}

				if (consent.necessary && !global.functionalScriptsLoaded) {
					global.functionalScriptsLoaded = true;
				}

				if (consent.embeds && !global.embeddedContentLoaded) {
					window.BMCookieConsent.loadEmbeddedContent();
					global.embeddedContentLoaded = true;
				}
			},

			gtag: function() {
				window.dataLayer = window.dataLayer || [];
				dataLayer.push(arguments);
			},

			initGoogleTagManager: function() {
				console.info('Initializing Google Tag Manager');
				console.info(BMBGThemeSettings);

				if (!BMBGThemeSettings || !BMBGThemeSettings.GTMCode) {
					console.error('No GTM code found');
					return;
				}

				fn.gtag('consent', 'default', {
					'ad_storage': 'denied',
					'ad_user_data': 'denied',
					'ad_personalization': 'denied',
					'analytics_storage': 'denied',
					'personalization_storage': 'denied',
					'functionality_storage': 'denied',
					'security_storage': 'denied'
				});

				(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
				new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
				'https://www.googletagmanager.com/gtm.js?id='+i+dl;j.setAttribute('nonce',BMBGThemeSettings.GTMNonce);f.parentNode.insertBefore(j,f);
				})(window,document,'script','dataLayer', BMBGThemeSettings.GTMCode);
			},

			enableGoogleAnalytics: function() {
				console.info('Enabling Google Analytics');

				fn.gtag('consent', 'update', {
					'ad_storage': 'granted',
					'ad_user_data': 'granted',
					'ad_personalization': 'granted',
					'analytics_storage': 'granted',
					'personalization_storage': 'granted',
					'functionality_storage': 'granted',
					'security_storage': 'granted'
				});
			},
		};

		jQuery(document).ready(fn.init);

	}

	new BMCookieBanner();

})();